import React, { useEffect, useState } from 'react';
import Header from '../../Header/Header';
import SideBar from '../../SideBar/SideBar';
import Footer from '../../Footer/Footer';
import { Link } from 'react-router-dom';
import { getIndividualUnivrsity } from '../../HttpRequest/userdetails';
import UniversityData from '../../commen/universityinterface';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const Singleuniversity = () => {
  const location = useLocation();
  const data = location.state && location.state.data;

  const [university, setuniversity] = useState({
    SingleuniversityeData: UniversityData(),
  });


  useEffect(() => {
    console.log("data to single univercity", location.state)
    if (data) {

      setuniversity({
        SingleuniversityeData: data,
      })
      console.log("data to single univercity", university)
      // getIndividualUnivrsity(id)
      //   .then((response) => {
      //     console.log("SingleuniversityeData response", response.data);
      //     setuniversity({
      //       SingleuniversityeData: response.data,
      //     }
      //     );
      //   })
    }
  }, []
  )



  return (
    <div className="main-wrapper">
      {/* Header */}
      <Header />

      {/* Sidebar */}
      <SideBar />

      {/* Page Wrapper */}
      <div className="page-wrapper">

        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title"> University</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admindashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">University</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Display data from myObject */}
          <div className="carddesing m-1">
            {university && (

              <div className="card singleuniversitygrid">
                {/* <div className="card-header">Featured</div>
              <div className="card-body">

              </div> */}

                <div className='universitycard-conatiner'>
                  <img src='https://upload.wikimedia.org/wikipedia/commons/c/cd/University-of-Alabama-EngineeringResearchCenter-01.jpg' alt='universit-image' className='university-image' />

                  <div className='textdes mt-2'>
                    <h6> <i class="fa-solid fa-building-columns"></i> {university.SingleuniversityeData.university}</h6>

                  </div>
                  <div className='textdes'>
                    <p><i class="fa-solid fa-location-dot"></i>  {university.SingleuniversityeData.campus} </p>
                  </div>
                  <div className='textdes'>
                    <p><i class="fa-solid fa-globe"></i>  {university.SingleuniversityeData.country} </p>
                  </div>
                  <div className='textdes'>
                    <p><i class="fa-solid fa-money-bills"></i>  Year tuition Fee :  {university.SingleuniversityeData.yearlyTuitionFees}</p>
                  </div>
                  <div className='textdes'>
                    <p><i class="fa-solid fa-comments-dollar"></i>  Application Fee :{university.SingleuniversityeData.applicationFee}</p>
                  </div>
                  {/* <button className='btn btn-primary applystyle'>Apply Now</button> */}
                </div>
                <div className='university-space-container'></div>
                <div className='university-deatail-conatiner'>

                  <div className='circlebox'>
                    <Link to="/normalsearch"> <div className='circlecontaner'>X</div></Link>
                  </div>
                  <div className='textdes mt-2'>
                    <h6 style={{ color: '#2C63E1', fontSize: '18px' }}> {university.SingleuniversityeData.name}</h6>

                  </div>
                  <div className='textdes'>
                    <i class="fa-solid fa-graduation-cap"></i> <p > Study Level : {university.SingleuniversityeData.studyLevel} </p>

                  </div>
                  <div className='textdes'>
                    <i class="fa-solid fa-graduation-cap"></i> <p > Duration : {university.SingleuniversityeData.duration} </p>

                  </div>
                  <div className='textdes'>
                    <i class="fa-solid fa-graduation-cap"></i> <p > Application Deadline : <strong>{university.SingleuniversityeData.applicationDeadline}</strong> </p>

                  </div>
                  <div className='textdes'>
                    <i class="fa-solid fa-graduation-cap"></i> <p >  </p>

                  </div>
                  <div className='mt-2'>
                    <h6 style={{ color: '#2C63E1' }}> Entry Requirements</h6>
                  </div>
                  <div className='mt-2'>
                    <div className='card cardbo'>
                      <div className='box'>
                        GRE
                        <p className='hrtag'></p>
                        {university.SingleuniversityeData.greScore ? university.SingleuniversityeData.greScore : <>0</>}
                      </div>
                      <div className='box'>
                        GPA
                        <p className='hrtag'></p>
                        {university.SingleuniversityeData.greScore ? university.SingleuniversityeData.greScore : <>0</>}
                      </div>
                      <div className='box'>
                        IELTS
                        <p className='hrtag'></p>
                        {university.SingleuniversityeData.ieltsScore ? university.SingleuniversityeData.ieltsScore : <>0</>}
                      </div>
                      <div className='box'>
                        TOEFL
                        <p className='hrtag'></p>
                        {university.SingleuniversityeData.tofelScore ? university.SingleuniversityeData.tofelScore : <>0</>}
                      </div>

                      <div className='box'>
                        DET
                        <p className='hrtag'></p>
                        {university.SingleuniversityeData.detScore ? university.SingleuniversityeData.detScore : <>0</>}
                      </div>

                      <div className='box'>
                        PTE
                        <p className='hrtag'></p>
                        {university.SingleuniversityeData.pteScore ? university.SingleuniversityeData.pteScore : <>0</>}
                      </div>
                    </div>
                    <div className='textdes'>
                      <i class="fa-solid fa-graduation-cap"></i> <p > <strong>Intakes </strong> :  <strong> {university.SingleuniversityeData.intakes} | Open </strong> </p>

                    </div>
                    <p>Course URL :  <a href={university.SingleuniversityeData.websiteURL} target='_blank'>{university.SingleuniversityeData.websiteURL}  </a></p>
                  </div>
                  <dv></dv>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Singleuniversity;
